import React from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

const CabinContainer = styled.div`
    display: flex;
    justify-content: center;
    flex-direction: column;
    width:100%;
    cursor: pointer;
    padding: 0px 25px 0px 25px;
    min-height: 70px;
    max-height: 120px;
    &:hover {
      opacity: 0.5;
      transition: all 0.5s;
    }
`;

const DescriptionContainer = styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    width:100%;
    cursor: pointer;
    height: 40%;
    font-size: 18px;
`;

const PersonContainer = styled.ul`
    display:flex;
    flex-direction: row;
    align-items: center;
    width:100%;
    list-style-type: none;
    padding: 0;
    height: 60%;
`;

const PersonItem = styled.li`
    display:flex;
    flex-direction: row;
    border: 1px solid #ccc;
    padding:5px 10px 5px 5px;
    border-radius: 5px;
    margin: 0 5px 0 5px;
`;

const SinglePerson = styled.div`
    & > span:nth-child(odd) {
      margin: 0 5px 0 5px;
    }
`;

const DeleteButton = styled.button`
    display: flex;
    justify-content: flex-start;
    align-items: center;
    margin: 0px 5px 0px 10px;
    border: none;
    background: none;
    cursor: pointer;
    &:hover {
      opacity: 0.5;
    }
`;

const guestsInCabin = (personsLinkedToCabin, id) => personsLinkedToCabin && personsLinkedToCabin
.filter(obj => obj.cabin === id)
.map(item => item.guests.combinedFirstNameAndLastName)
.map(guest => guest.map((g, i) => <SinglePerson><span>{g.firstName}</span><span>{g.lastName}{i < guest.length - 1 ? ', ' : null}</span></SinglePerson>));

const renderDeleteperson = (personsLinkedToCabin, removePersonFromPersonsLinkedToCabinImportedFile, id) => personsLinkedToCabin ? <DeleteButton key={`delete-${id}`} onClick={() => removePersonFromPersonsLinkedToCabinImportedFile(id)}>X</DeleteButton> : null;

const SingleCabin = ({
  data,
  setActiveCabinForImportedFileCabinDistributor,
  activeCabinInCabinDistributor,
  personsLinkedToCabin,
  personsInCabin,
  removePersonFromPersonsLinkedToCabinImportedFile,
  selectCabinInfoStartedDescription,
  selectCabinInfoEmptyDescription,
}) => (
  <CabinContainer
    role="button"
    tabIndex={0}
    onClick={() => personsInCabin ? null : setActiveCabinForImportedFileCabinDistributor(data.id)}
    className={[
      activeCabinInCabinDistributor === data.id ? 'selected-cabin-div' : '',
    ].join(' ')}
  >
    <DescriptionContainer>
      <span>{data.description}</span>
      <span>{selectCabinInfoStartedDescription}: {data.noOfBerths - (personsLinkedToCabin && Number(personsLinkedToCabin.filter(obj => obj.cabin === data.id).map(item => item.guests && item.guests.id.length)))}</span>
    </DescriptionContainer>
    <PersonContainer>{personsInCabin ? <PersonItem>{[guestsInCabin(personsLinkedToCabin, data.id), renderDeleteperson(personsLinkedToCabin, removePersonFromPersonsLinkedToCabinImportedFile, data.id)]}</PersonItem> : selectCabinInfoEmptyDescription}</PersonContainer>
  </CabinContainer>
);

SingleCabin.propTypes = {
  data: PropTypes.object,
  setActiveCabinForImportedFileCabinDistributor: PropTypes.func,
  activeCabinInCabinDistributor: PropTypes.string,
  personsLinkedToCabin: PropTypes.array,
  personsInCabin: PropTypes.bool,
  removePersonFromPersonsLinkedToCabinImportedFile: PropTypes.func,
  selectCabinInfoStartedDescription: PropTypes.string,
  selectCabinInfoEmptyDescription: PropTypes.string,
};

export default SingleCabin;



// WEBPACK FOOTER //
// ./src/components/organisms/ImportFile/steps/cabin/singleCabin.js